// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__z7+I3","open":"Modal_open__iRQcY"};